<template>
  <div class="comment">
    <!-- 顶部导航 -->
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
      <span>商品评价
      </span>
      <div></div>
    </div>
    <!-- 评论列表 -->
    <van-list :finished="finished" v-model="loading" finished-text="我是有底线的" @load="onLoad">
      <div class="main">
        <div class="list" v-for="(item,index) in userList">
          <div class="user">
            <img src="../../assets/touxiang.png" alt="" v-if="item.anonymous == 0">
            <img src="../../assets/user.png" alt="" v-else-if="item.user.image == null">
            <img :src="item.user.image | handleUrl" alt="" v-else>
            <span class="user-span" v-if="item.anonymous == 0">神秘人</span>
            <span class="user-span" v-else>{{item.user.username}}</span>
          </div>
          <div class="time">
            <van-rate :value="item.hot_num" readonly color="#ff4e35" size="0.5rem" gutter="0.3rem" />
            <div>{{item.create_time}}</div>
          </div>
          <div class="user-msg" v-if="item.content == ''">该用户暂无评论</div>
          <div class="user-msg" v-else>{{item.content}}</div>
          <div class="user_img">
            <img @click="getImg(items)" v-for="items in item.image" :src="items | handleUrl" alt="">
            <van-image-preview v-model="show" :images="image"></van-image-preview>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userList: [],
        show: false,
        image: [],
        loading: false,
        finished: false,
        pages: 1
      }
    },
    methods: {
      //上拉加载评论
      onLoad() {
        //异步更新数据
        this.$axios.post(baseUrl + '/mobile/Goods/goodsComment', {
          id: this.$route.query.page,
          page: this.pages,
          limit: 5
        }).then((res) => {
          if (res.data.code == 2) {
            this.pages++;
            setTimeout(() => {
              for (var i in res.data.data) {
                this.userList.push(res.data.data[i])
              }
              // 加载状态结束
              this.loading = false;
            }, 500)
          } else {
            this.loading = false;
            this.finished = true;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      //预览图
      getImg(img) {
        this.show = true;
        this.image = [];
        this.image.push(baseUrl + '/uploads/' + img);
      }
    }
  }
</script>

<style scoped>
  @import "comment.css"
</style>



// WEBPACK FOOTER //
// src/components/detail/comment.vue